/* eslint-disable import/prefer-default-export */
import get from 'lodash/get';
import { selectParsedCustomAttributes } from 'store/CustomAttributes/selectors';
import defaultFields from 'store/ManageGeneral/fields';
import { EXCLUDED_VULN_TABLE_FIELDS } from 'store/Manage/vulnColumns';

export const selectVulnsAssetFields = (state) => {
  const preferencesFields = get(state, 'preferences.manage_table', {});
  const defaultFieldsKeys = Object.keys(defaultFields);

  const excludedFields = [...EXCLUDED_VULN_TABLE_FIELDS, 'params', 'pname', 'references', 'policyviolations', 'evidence', 'asset', 'workspace_name'];
  const customFields = selectParsedCustomAttributes(state);
  const customFieldsKeys = Object.keys(customFields);

  const defaultMergedFields = defaultFieldsKeys.reduce((acc, key) => {
    const defaultField = defaultFields[key];
    const currentField = get(preferencesFields, key, {});
    const mergedField = {
      ...defaultField,
      ...currentField
    };

    if (defaultField.locked) {
      mergedField.order = defaultField.order;
      mergedField.visible = defaultField.visible;
    }

    acc[key] = mergedField;
    return acc;
  }, {});

  const nonDefaultFields = Object.keys(preferencesFields)
    .filter((key) => !defaultFieldsKeys.includes(key))
    .reduce((acc, key) => {
      acc[key] = preferencesFields[key];
      return acc;
    }, {});

  let fields = {
    ...defaultMergedFields,
    ...nonDefaultFields
  };

  const onlyDefaultFields = Object.keys(fields).filter(
    e => !customFieldsKeys.includes(e) || defaultFieldsKeys.includes(e)
  );

  fields = onlyDefaultFields.reduce((filteredFields, field) => {
    if (!excludedFields.includes(field)) {
      filteredFields[field] = fields[field];
    }
    return filteredFields;
  }, {});

  return fields;
};
